import { getErrorMessage } from "@/core/services";
import { useAsyncQuery } from "@/ds";
import {
  listFinanceiroEmbarcacoes,
  listFinanceiroTiposObra,
} from "@/modules/financeiro-obras/financeiro-obras.gateway";
import type {
  FinanceiroEmbarcacaoOpcao,
  FinanceiroLookupState,
  FinanceiroTipoObraOpcao,
} from "@/modules/financeiro-obras/financeiro-obras.types";

export const FINANCEIRO_LOOKUP_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar os dados do Financeiro.";
export const FINANCEIRO_LOOKUP_ERROR_MESSAGE = "Não foi possível carregar os dados.";

function useFinanceiroLookup<T>(
  load: (signal: AbortSignal) => Promise<T>,
  initial: T,
  key: string,
): FinanceiroLookupState<T> {
  const { status, data, errorMessage } = useAsyncQuery({
    fetcher: load,
    queryKey: key,
    initialData: initial,
    forbiddenMessage: FINANCEIRO_LOOKUP_FORBIDDEN_MESSAGE,
    errorMessage: FINANCEIRO_LOOKUP_ERROR_MESSAGE,
    resolveErrorMessage: getErrorMessage,
  });

  return { status, data, errorMessage };
}

const NO_EMBARCACOES: FinanceiroEmbarcacaoOpcao[] = [];
const NO_TIPOS_OBRA: FinanceiroTipoObraOpcao[] = [];

/** Opções do filtro Embarcação (privilégio `hub.financeiro:view-painel`). */
export function useFinanceiroEmbarcacoes() {
  return useFinanceiroLookup(
    (signal) => listFinanceiroEmbarcacoes({ signal }),
    NO_EMBARCACOES,
    "embarcacoes",
  );
}

/** Opções do filtro Tipo (privilégio `hub.financeiro:view-painel`). */
export function useFinanceiroTiposObra() {
  return useFinanceiroLookup(
    (signal) => listFinanceiroTiposObra({ signal }),
    NO_TIPOS_OBRA,
    "tipos-obra",
  );
}
